/* Empress Notify me: "email me when it's back" on sold out sizes (snippets/notify-me.liquid).
   Replaced AMP Back in Stock (Oct 2026). v2, 16 Oct 2026: one calm step in the Add to cart spot.

   Shows only when the picked size is sold out (CSS in snippets/notify-head.liquid then hides the dead
   Sold out button, the quantity and the sticky bar). Reads the size the way the size gate does
   (assets/require-size.js): the checked radio's data-sg-variant and data-sg-available, stamped
   server-side in snippets/option-value.liquid. Products with more than one option use the picker's
   own selected variant once every option is picked. Products with no size picker use the variant
   the snippet rendered with.

   Shoppers we know tap once: signed in, or a guest whose email this phone remembers from her last
   Notify me (shown part hidden, with Not you?). Guests type an email and tap once.
   The email list is never on the form: after she is on the list, a one tap "Email me about new drops
   too", never ticked for her. It sends the same request again with c: true (the planner records it).
   Offered only when the email is surely hers: signed in, or typed this time. Never for a remembered
   email (a shared phone: it could be someone else's). Not you? forgets everything this phone kept.

   Posts to /apps/empress-fit/notify (Shopify app proxy to the planner, lib/notify.ts):
   { p, v, e (guests), c (said yes to the email list), a (device id), s, hp (bots only) }.
   A size she asked about shows done on this device for 45 days, or until it is back in stock.
   Nothing below moves when she taps sizes: on a sold out size this card takes exactly the room the
   in stock layout had (stock line, quantity, Afterpay, Add to cart), measured just before it swaps. */
(function () {
  if (!window.customElements || customElements.get('notify-me')) return;

  var API = '/apps/empress-fit/notify';
  var ASKED = 'ee:notify:asked';
  var EMAIL = 'ee:notify:email';
  var JOINED = 'ee:notify:joined';
  var ANON = 'ee:wl:anon'; /* the wishlist's device id (assets/wishlist.js), shared */
  var KEEP_MS = 45 * 86400000;

  function store(k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }

  /* { variantId: askedAt } */
  function askedMap() {
    try {
      var m = JSON.parse(read(ASKED) || '{}');
      return m && typeof m === 'object' && !Array.isArray(m) ? m : {};
    } catch (e) { return {}; }
  }
  function saveAsked(m) {
    var now = Date.now();
    var keys = Object.keys(m).filter(function (k) { return now - m[k] < KEEP_MS; });
    keys.sort(function (a, b) { return m[b] - m[a]; });
    var out = {};
    keys.slice(0, 60).forEach(function (k) { out[k] = m[k]; });
    store(ASKED, JSON.stringify(out));
  }
  function hasAsked(v) { var t = askedMap()[v]; return !!t && Date.now() - t < KEEP_MS; }
  function remember(v) { var m = askedMap(); m[v] = Date.now(); saveAsked(m); }
  function forget(v) { var m = askedMap(); if (m[v]) { delete m[v]; saveAsked(m); } }

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function rememberedEmail() { var e = read(EMAIL); return e && EMAIL_RE.test(e) ? e : null; }
  /* "an•••@gmail.com": enough for her to know it's hers, not enough for someone else on the phone */
  function masked(e) {
    var at = e.indexOf('@');
    return e.slice(0, Math.min(2, at)) + '•••' + e.slice(at);
  }

  var pageId = null;
  function newId() {
    return (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : 'n' + Date.now().toString(36) + Math.random().toString(36).slice(2, 12);
  }
  /* the planner needs a device id for guests; with storage blocked, one for this page */
  function anonId() {
    var a = read(ANON);
    if (a) return a;
    a = newId();
    store(ANON, a);
    return read(ANON) || pageId || (pageId = a);
  }
  function esc(s) { return (window.CSS && CSS.escape) ? CSS.escape(s) : s; }
  function track(name, p, v) {
    try { if (window.gtag) window.gtag('event', name, { items: [{ item_id: 'shopify_AU_' + p + '_' + v }] }); } catch (e) {}
    try { if (window.clarity) window.clarity('event', name); } catch (e) {}
  }
  /* one size products: no "OS is sold out", just "Sold out" */
  var ONE_SIZE = /^(os|o\/s|one size|onesize|default title)$/i;
  function sizeOf(s) { s = (s || '').trim(); return ONE_SIZE.test(s) ? '' : s; }
  function withSize(text, size) {
    if (size) return text.replace(/\{size\}/g, size);
    /* no size (one size products): "Notify me when it's back", "You're on the list." */
    return text.replace(/\s*for \{size\}/g, '').replace(/\{size\} is/g, "it's").replace(/\{size\}/g, 'it');
  }

  class NotifyMe extends HTMLElement {
    connectedCallback() {
      var self = this;
      /* quick buy moves its modal to <body>, which reconnects this: one set of listeners per connection */
      this.ac = new AbortController();
      var on = { signal: this.ac.signal };
      this.formId = this.getAttribute('form') || '';
      this.signedIn = this.hasAttribute('signed-in');
      this.subscribed = this.hasAttribute('subscribed');
      this.ask = this.querySelector('.ee-notify__ask');
      this.lede = this.querySelector('.ee-notify__lede');
      this.form = this.querySelector('form');
      this.email = this.form.querySelector('input[type="email"]');
      this.who = this.querySelector('.ee-notify__who');
      this.to = this.querySelector('.ee-notify__to');
      this.sendBtn = this.querySelector('.ee-notify__send');
      this.msg = this.querySelector('.ee-notify__msg');
      this.done = this.querySelector('.ee-notify__done');
      this.optinBtn = this.querySelector('.ee-notify__optin');
      this.joined = this.querySelector('.ee-notify__joined');
      this.variant = null;
      this.size = '';
      this.busy = false;
      this.lastEmail = null;
      this.typedNow = false;

      document.addEventListener('change', function (e) {
        var t = e.target;
        if (t && t.type === 'radio' && t.closest && t.closest('variant-picker') === self.picker() && !self.multi()) self.sync();
      }, on);
      /* the theme rewrites the product info after a size change: look again once it settles */
      document.addEventListener('variant:change', function () { setTimeout(function () { self.sync(); }, 0); }, on);
      this.form.addEventListener('submit', function (e) { e.preventDefault(); self.send(); }, on);
      this.optinBtn.addEventListener('click', function () { self.optin(); }, on);
      var notYou = this.querySelector('.ee-notify__notyou');
      if (notYou) notYou.addEventListener('click', function () {
        store(EMAIL, null);
        store(ASKED, null);
        store(JOINED, null);
        self.setMode();
        if (self.email) { try { self.email.focus(); } catch (e) {} }
      }, on);
      /* 6. a rotate or a resize: measure the room again (hidden for one moment, never painted) */
      var lastWidth = window.innerWidth;
      window.addEventListener('resize', function () {
        clearTimeout(self.resizeTimer);
        self.resizeTimer = setTimeout(function () {
          if (window.innerWidth === lastWidth) return; /* the phone's address bar, not a real resize */
          lastWidth = window.innerWidth;
          if (self.hidden) return;
          self.hidden = true;
          var room = self.span();
          self.hidden = false;
          if (room > 0) self.room = room;
          self.hold();
        }, 150);
      }, on);
      this.sync();
      /* quick buy can arrive with a sold out size ticked that the size gate then unticks quietly: look again */
      setTimeout(function () { self.sync(); }, 30);
    }

    disconnectedCallback() {
      if (this.ac) this.ac.abort();
    }

    picker() {
      return this.formId ? document.querySelector('variant-picker[form-id="' + esc(this.formId) + '"]') : null;
    }

    /* more than one option (colour and size): sync on variant:change only */
    multi() {
      var picker = this.picker();
      if (!picker) return false;
      var names = {};
      Array.prototype.forEach.call(picker.querySelectorAll('input[type="radio"][name]'), function (r) { names[r.name] = 1; });
      return Object.keys(names).length > 1;
    }

    /* The picked size: { id, available, size }, or null when none is picked. */
    current() {
      var picker = this.picker();
      var radios = picker ? picker.querySelectorAll('input[type="radio"][name]') : [];
      if (!radios.length) {
        var id = this.getAttribute('variant-id');
        return id ? { id: id, available: this.getAttribute('variant-available') === 'true', size: this.getAttribute('variant-size') || '' } : null;
      }
      var groups = {};
      Array.prototype.forEach.call(radios, function (r) { (groups[r.name] = groups[r.name] || []).push(r); });
      var names = Object.keys(groups);
      var chosen = names.every(function (n) { return groups[n].some(function (r) { return r.checked; }); });
      if (!chosen) return null;
      if (names.length > 1) {
        /* more than one option: the stamped variant isn't reliable, the picker's own is (it updates on variant:change) */
        var sv = picker.selectedVariant;
        return sv && sv.id ? { id: String(sv.id), available: !!sv.available, size: sv.title || '' } : null;
      }
      var checked = Array.prototype.find.call(radios, function (r) { return r.checked; });
      if (!checked.getAttribute('data-sg-variant')) return null;
      var label = checked.id ? document.querySelector('label[for="' + esc(checked.id) + '"]') : null;
      return {
        id: checked.getAttribute('data-sg-variant'),
        available: checked.getAttribute('data-sg-available') !== '0',
        size: label ? (label.textContent || '').replace(/\s+/g, ' ').trim() : ''
      };
    }

    sync() {
      var c = this.current();
      /* back in stock: whatever she asked before is done with */
      if (c && c.available) forget(c.id);
      var show = !!(c && !c.available);
      /* the in stock layout, just before the swap: the room this card will take */
      if (show && this.hidden) { var room = this.span(); if (room > 0) this.room = room; }
      this.hidden = !show;
      if (!show) { this.variant = null; this.style.minHeight = ''; return; }
      if (c.id === this.variant) { this.hold(); return; }
      this.variant = c.id;
      this.size = sizeOf(c.size);
      this.setMsg('');
      if (hasAsked(c.id)) this.showDone(false, false);
      else {
        this.ask.hidden = false;
        this.done.hidden = true;
        this.setMode();
      }
      this.hold();
    }

    /* From the bottom of the size picker to the bottom of this block: what the swap must not change. */
    span() {
      var item = this.closest('.product-info__block-item');
      var list = item && item.closest('.product-info__block-list');
      var anchor = list && list.querySelector('.product-info__block-item[data-block-type="variant-picker"]');
      if (!item || !anchor) return null;
      return item.getBoundingClientRect().bottom - anchor.getBoundingClientRect().bottom;
    }

    /* Take exactly the room the in stock layout had, so everything below stays where it was:
       stacked when there's room, email and button on one row when it's tight (a sold out product
       with no quantity, the quick buy drawer), then grow to the exact height. */
    hold() {
      if (!this.room || this.hidden) return;
      this.classList.remove('is-compact');
      this.style.minHeight = '';
      var now = this.span();
      if (now == null) return;
      if (now > this.room + 0.5 && this.email && !this.email.hidden) {
        this.classList.add('is-compact');
        now = this.span();
      }
      var extra = this.room - now;
      if (extra > 0.5) this.style.minHeight = (this.getBoundingClientRect().height + extra) + 'px';
    }

    /* One tap for shoppers we know; an email box for everyone else. */
    setMode() {
      var saved = this.signedIn ? null : rememberedEmail();
      var known = this.signedIn || !!saved;
      var sold = this.size ? this.size + ' ' + (this.getAttribute('sold-text') || 'is sold out.') : (this.getAttribute('soldout-text') || 'Sold out.');
      /* the same line for everyone: what's sold out, and what happens */
      this.lede.textContent = (sold ? sold + ' ' : '') + (this.getAttribute('lede-text') || '');
      this.lede.hidden = !this.lede.textContent;
      /* signed in: where the email goes, part hidden */
      var mine = this.signedIn ? this.getAttribute('customer-email') || '' : '';
      if (this.to) {
        this.to.hidden = !EMAIL_RE.test(mine);
        this.to.textContent = this.to.hidden ? '' : (this.getAttribute('to-text') || 'To') + ' ' + masked(mine);
      }
      this.sendBtn.textContent = known
        ? withSize(this.getAttribute('tap-text') || 'Notify me when {size} is back', this.size)
        : (this.getAttribute('send-text') || 'Notify me');
      if (this.email) {
        this.email.hidden = known;
        this.email.required = !known;
      }
      if (this.who) {
        this.who.hidden = !saved;
        if (saved) this.who.querySelector('[data-notify-who]').textContent = (this.getAttribute('as-text') || 'As') + ' ' + masked(saved) + '.';
      }
      /* the button and the box say which size: the line above them */
      this.sendBtn.setAttribute('aria-describedby', this.lede.id + ' ' + this.msg.id);
    }

    setMsg(text) {
      this.msg.textContent = text;
      if (this.email) {
        if (text && !this.email.hidden) this.email.setAttribute('aria-invalid', 'true');
        else this.email.removeAttribute('aria-invalid');
      }
    }

    showDone(fresh, focus) {
      this.ask.hidden = true;
      this.done.hidden = false;
      this.done.querySelector('.ee-notify__done-line').textContent = withSize(this.getAttribute('done-text') || "You're on the list for {size}.", this.size);
      this.done.querySelector('.ee-notify__done-sub').textContent = this.getAttribute('lede-text') || '';
      /* the email list: only straight after she joins, never for someone already on it */
      var hers = this.signedIn ? !this.subscribed : this.typedNow;
      var offer = fresh && hers && !read(JOINED);
      this.optinBtn.hidden = !offer;
      this.optinBtn.disabled = false;
      this.optinBtn.textContent = this.getAttribute('optin-text') || 'Email me about new drops too';
      this.joined.hidden = true;
      this.hold();
      if (focus) { try { this.done.focus({ preventScroll: true }); } catch (e) {} }
    }

    body(consent) {
      var hp = this.form.querySelector('input[name="hp"]');
      return {
        p: this.getAttribute('product-id'),
        v: this.variant,
        e: this.signedIn ? undefined : this.lastEmail,
        c: consent,
        a: anonId(),
        s: this.getAttribute('source') || 'pdp',
        hp: hp ? hp.value : ''
      };
    }

    post(body) {
      /* 15s at most: on a launch rush a stuck request must never leave the button busy */
      var ac = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = ac ? setTimeout(function () { ac.abort(); }, 15000) : 0;
      return fetch(API, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body), signal: ac ? ac.signal : undefined })
        .then(function (r) { return r.json().catch(function () { return null; }).then(function (j) { return { status: r.status, json: j || {} }; }); })
        .then(function (res) { clearTimeout(timer); return res; }, function (err) { clearTimeout(timer); throw err; });
    }

    why(res) {
      var j = res.json;
      return j.error === 'email' ? (this.getAttribute('email-error') || 'Enter a valid email')
        : j.error === 'instock' ? 'Good news. It’s back in stock. Refresh to add it to your bag.'
        : j.error === 'limit' ? 'You’re already waiting on lots of sizes.'
        : res.status === 429 ? 'Too many tries. Try again in a few minutes.'
        : j.error === 'gone' ? 'This size is no longer available.'
        : 'That didn’t work. Try again.';
    }

    send() {
      if (this.busy || !this.variant) return;
      var self = this;
      if (this.signedIn) {
        this.lastEmail = null;
        this.typedNow = false;
      } else if (this.email && !this.email.hidden) {
        /* the box is showing: what she typed, nothing else */
        var typed = this.email.value.trim();
        if (!typed || !EMAIL_RE.test(typed) || !this.email.checkValidity()) {
          this.setMsg(this.getAttribute('email-error') || 'Enter a valid email');
          this.email.focus();
          return;
        }
        this.lastEmail = typed;
        this.typedNow = true;
      } else {
        /* one tap with a remembered email, unless another tab forgot it meanwhile */
        var saved = rememberedEmail();
        if (!saved) { this.setMode(); return; }
        this.lastEmail = saved;
        this.typedNow = false;
      }
      var variant = this.variant;
      var product = this.getAttribute('product-id');
      this.busy = true;
      this.setMsg('');
      this.sendBtn.disabled = true;
      this.post(this.body(false))
        .then(function (res) {
          if (res.status < 300 && res.json.ok) {
            remember(variant);
            if (!self.signedIn && self.lastEmail) store(EMAIL, self.lastEmail);
            track('notify_me', product, variant);
            if (self.variant === variant) self.showDone(true, true);
          } else if (self.variant !== variant) {
            /* she moved to another size meanwhile: this answer isn't about it */
          } else if (res.json.error === 'email' && !self.signedIn && !self.typedNow) {
            /* the remembered email no longer works: back to the email box */
            store(EMAIL, null);
            self.setMode();
            self.setMsg(self.why(res));
          } else {
            self.setMsg(self.why(res));
          }
        })
        .catch(function () { if (self.variant === variant) self.setMsg('That didn’t work. Try again.'); })
        .then(function () {
          self.busy = false;
          self.sendBtn.disabled = false;
        });
    }

    /* One tap yes to the email list, after she joined: the same request again, with consent. */
    optin() {
      if (this.busy || !this.variant) return;
      var self = this;
      var variant = this.variant;
      this.busy = true;
      this.optinBtn.disabled = true;
      this.post(this.body(true))
        .then(function (res) {
          if (res.status < 300 && res.json.ok) {
            store(JOINED, String(Date.now()));
            track('notify_me_optin', self.getAttribute('product-id'), variant);
            self.joined.textContent = self.getAttribute('joined-text') || 'You’re in for new drops.';
            self.joined.hidden = false;
            try { self.joined.focus({ preventScroll: true }); } catch (e) {}
            self.optinBtn.hidden = true;
          } else {
            self.optinBtn.disabled = false;
            self.joined.textContent = self.why(res);
            self.joined.hidden = false;
          }
        })
        .catch(function () {
          self.optinBtn.disabled = false;
          self.joined.textContent = 'That didn’t work. Try again.';
          self.joined.hidden = false;
        })
        .then(function () { self.busy = false; });
    }
  }

  customElements.define('notify-me', NotifyMe);
})();
